import { useState } from 'react';
import { useAuth } from './useAuth';
import { hacerSolicitud } from '../helpers/apiClient';
import { urlApi } from '../helpers/functionHelpers';

const useActualizarStatusProveedor = () => {
  const { renovarToken, cerrarSesion } = useAuth(); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const actualizarStatusProveedor = async (folio, nuevoStatusId) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await hacerSolicitud(
        `${urlApi}/api/proveedor/${folio}/status`,
        {
          method: 'PUT',
          body: JSON.stringify({ nuevoStatusId }),
        },
        renovarToken,
        cerrarSesion,
        false
      );

      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { actualizarStatusProveedor, loading, error, success };
};

export default useActualizarStatusProveedor;
